import {
  FormControlLabel as MuiFormControlLabel,
  Switch as MuiSwitch,
} from '@mui/material';
import { ISwitchProps } from './Switch.types';

export default function Switch({
  label,
  labelPlacement = 'end',
  ...props
}: ISwitchProps) {
  if (label) {
    return (
      <MuiFormControlLabel
        control={<MuiSwitch {...props} />}
        label={label}
        labelPlacement={labelPlacement}
      />
    );
  } else {
    return <MuiSwitch {...props} />;
  }
}
